<template>
	<v-runtime-template :template="'<' + root + '>' + text + '</' + root + '>'"></v-runtime-template>
</template>

<script>
import VRuntimeTemplate from "v-runtime-template";

export default {
	props: {
		root: { type: String, default: "div" },
		text: { type: String, default: "" },
	},
	components: {
		VRuntimeTemplate
	},
};
</script>